import moment from 'moment'
import { TokenHeaderModel } from 'models/TokenHeaderModel'

export const isCurrentLoginSession = (header: TokenHeaderModel, now = Date.now()): boolean =>
  !!header?.iat && !!header?.exp && header.exp * 1000 > now &&
  moment(header.iat * 1000).format('YYYY-MM-DD') === moment(now).format('YYYY-MM-DD')
